import React from 'react';
import Hero from '../../components/Hero';
import SalesSection from '../../components/SalesSection';
import Services from '../../components/Services';
import TechStack from '../../components/TechStack';
import Portfolio from '../../components/Portfolio';
import Contact from '../../components/Contact';

const Home: React.FC = () => (
  <>
    <Hero />
    <Services />
    <TechStack />
    <Portfolio />
    <SalesSection />
    <Contact />
  </>
);

export default Home;
